let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("89WyM"), load("ffEVr"), load("gqoMB")]).then(() => parcelRequire('bqjR5'));